export const isBrowser = (): boolean => {
  try {
    return typeof window === "object"
  } catch (e) {
    return false
  }
}

export const isServer = (): boolean => {
  try {
    return typeof window === "undefined"
  } catch (e) {
    return true
  }
}
